// ** React Imports
import React, { ReactNode, useEffect } from 'react'

// ** MUI Imports
import { CircularProgress } from '@mui/material'

// ** Modules Imports
import { useIntl } from 'react-intl'
import { useStore } from 'effector-react'

// ** Source code Imports
import globalStore from 'src/state-manager/global'
import tableColumnKeysConf from 'src/configs/db-columns-keys'
import tableEnumV2OptionsConf from 'src/configs/db-enum-v2-options'
import DocsLayout from 'src/layouts/DocsLayout'
import { Box } from '@mui/system'
import landingStore, { getLandingDetail } from 'src/state-manager/landing'

const keyValuesKeys = tableColumnKeysConf.keyValues
const keyValuesEnum = tableEnumV2OptionsConf.keyValues

const CookiesPolicy = () => {
  const { formatMessage } = useIntl()

  const { language } = useStore(globalStore.locale)

  const { landingDetails } = useStore(landingStore.landing)

  useEffect(() => {
    getLandingDetail({
      query: {
        $or: [{ 'data.groupName': 'landing' }, { 'data.groupName': 'shared' }],
        $and: [
          {
            [`data.${keyValuesKeys.language}`]:
              language === 'ru' ? keyValuesEnum.language.ru : keyValuesEnum.language.en
          }
        ]
      }
    })
  }, [language])

  return (
    <DocsLayout
      sx={{
        maxWidth: 768,
        height: landingDetails.loading ? 'auto' : 'calc(100vh - 64px)',
        mx: 'auto'
      }}
      title={formatMessage({ id: 'cookies-policy' })}
    >
      {landingDetails.loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', pt: 16 }}>
          <CircularProgress size={72} />
        </Box>
      ) : (
        <iframe
          width='100%'
          height='100%'
          style={{ border: 0, padding: 0 }}
          srcDoc={landingDetails.data['cookies-policy-text']}
        />
      )}
    </DocsLayout>
  )
}

CookiesPolicy.getLayout = (page: ReactNode) => page

CookiesPolicy.guestGuard = true

CookiesPolicy.acl = {
  action: 'read',
  subject: 'cookies-policy-page'
}

export default CookiesPolicy
